import { Injectable } from '@angular/core';
import {
	GtmDataLayerPayload,
	GtmEvent,
	GtmEventDataLayer,
	GtmExtras,
	GtmPage,
	GtmPageDataLayer,
} from 'src/app/interfaces/gtm.interface';
import { GtmEvents, GtmInteractiveKeys } from './gtm-utils';
import { environment } from 'src/environments';
import { BehaviorSubject } from 'rxjs';
@Injectable({
	providedIn: 'root',
})
export class GtmService {
	private extraData$ = new BehaviorSubject<Partial<GtmExtras> | null>(null);

	setExtras(extra: Partial<GtmExtras>): void {
		const current = this.extraData$.value ?? {};
		this.extraData$.next({ ...current, ...extra });
	}

	handlerEvent(event: GtmPage | GtmEvent): void {
		if ('page' in event) {
			this.triggerPage(event);
		} else {
			this.triggerEvent(event);
		}
	}

	private triggerPage(data: GtmPage): void {
		this.push({
			event: GtmEvents.pageVirtual,
			page: data.page,
			pagename: data.pagename,
		} satisfies GtmPageDataLayer);
	}

	private triggerEvent(data: GtmEvent): void {
		this.push({
			event: GtmEvents.interactive,
			[GtmInteractiveKeys.category]: data.category,
			[GtmInteractiveKeys.action]: data.action,
			[GtmInteractiveKeys.label]: data.label,
		} satisfies GtmEventDataLayer);
	}

	private push(data: GtmDataLayerPayload): void {
		if (!Array.isArray(window.dataLayer)) {
			if (!environment.production) console.warn('window.dataLayer no está definido');
			return;
		}

		const extras = this.extraData$.value ?? {};
		const payload: GtmDataLayerPayload = {
			...extras,
			...data,
		};

		window.dataLayer.push(payload);
		if (!environment.production) console.log(`${payload.event}:`, payload);
	}
}
